import { ReactNode } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

type CustomStyle = { color: string; zIndex?: number | string };
interface Props {
  children?: ReactNode;
  customStyle?: CustomStyle;
}

export default function FullScreenLoader({ customStyle, children }: Props) {
  return (
    <Backdrop
      sx={
        customStyle || {
          color: '#fff',
          zIndex: (theme: any) => theme.zIndex.drawer + 1
        }
      }
      open
    >
      {children || <CircularProgress color="inherit" />}
    </Backdrop>
  );
}
